import { useTranslations } from 'next-intl';

import Badge from '@/components/label/Badge';

import { isMovieReleaseDateNew } from '@/helpers/movie-helper';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

type MovieReleaseBadgeProps = {
    movieReleaseDate: string;
};

function MovieReleaseBadge(props: MovieReleaseBadgeProps) {
    const { movieReleaseDate } = props;

    const t = useTranslations();
    const { timeZone } = useDomainConfiguration();

    if (isMovieReleaseDateNew(movieReleaseDate, timeZone)) {
        return <Badge name={t('common.new')} />;
    }

    return null;
}

export default MovieReleaseBadge;
